import { render, staticRenderFns } from "./PrescribedBlanksTable.vue?vue&type=template&id=37e1f729&scoped=true"
import script from "./PrescribedBlanksTable.vue?vue&type=script&lang=js"
export * from "./PrescribedBlanksTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e1f729",
  null
  
)

export default component.exports